var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8454 1C16.5541 1 20.3736 4.90027 20.3736 9.70851C20.3736 14.5167 16.5541 18.417 11.8454 18.417C7.13667 18.417 3.31714 14.5167 3.31714 9.70851C3.31714 8.76628 3.46254 7.85831 3.73656 7.00744",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30957 7.44437L3.99946 6.65918L4.76561 9.40307",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.502 8.99463H8.90967V13.2775H14.502V8.99463Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7058 5.28296C12.7851 5.28296 13.6631 6.17951 13.6631 7.28163V8.99478H9.74854V7.28163C9.74854 6.17951 10.6265 5.28296 11.7058 5.28296Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7056 10.9934C11.8601 10.9934 11.9853 10.8656 11.9853 10.7079C11.9853 10.5502 11.8601 10.4224 11.7056 10.4224C11.5512 10.4224 11.426 10.5502 11.426 10.7079C11.426 10.8656 11.5512 10.9934 11.7056 10.9934Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7058 11.8499V10.9933",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordBlue);
export default __webpack_public_path__ + "static/media/PasswordBlue.6e1c6e5a73c56cfe3331adbb4881b984.svg";
export { ForwardRef as ReactComponent };